import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { BellAlert, PlusIcon } from "../../shared/assets/icons";
import img1 from "../../shared/assets/icons/image 12.png";

import { useState } from "react";
import { FiMenu } from "react-icons/fi"; // Importing the burger menu icon
import ClientRFPModal from "../../shared/createForms/ClientRFPModal";
import { Box, Modal } from "@mui/material";
import CapitalizeFirstLetter from "../../shared/utils/CapitalizeFirstLetter";

const Header = ({ isOpen }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    // Function to read the data from localStorage
    const syncLocalStorageWithState = () => {
      const storedEmail = localStorage.getItem("email");
      const storedName = localStorage.getItem("name");

      if (storedEmail !== email) setEmail(storedEmail);
      if (storedName !== name) setName(storedName);
    };

    // Sync when component mounts
    syncLocalStorageWithState();

    // Set up an interval to check for changes in localStorage
    const intervalId = setInterval(syncLocalStorageWithState, 1000); // Poll every 1 second

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [email, name]);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [rfpModalOpen, setRfpModalOpen] = useState(false);

  // Toggle the visibility of the small screen menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openModalRfp = () => {
    setRfpModalOpen(true);
  };

  const GenerateRFPForm = () => {
    navigate("/user/createRFP");
    <ClientRFPModal></ClientRFPModal>;
  };

  return (
    <div
      className={`flex flex-grow  justify-between items-center max-w-full  p-2 ${
        isOpen ? `ml-64 translate-x ` : `ml-14`
      } `}
      style={{ background: "var(--dashboard-bg-color)", height: "12vh" }}
    >
      <div
        className={`flex justify-between items-center w-full text-black p-2 ml-2  border-b-2 bg-[var(--dashboard-bg-color)] z-30 mr-4`}
      >
        {/* First Div with User Info */}
        <div className="firstDiv flex items-center">
          <div
            className="m-2 shake-hand"
            style={{ width: "43px", height: "43px" }}
          >
            <img src={img1} alt="User" className="w-full h-full" />
          </div>
          <div className="font-semi text-lg ml-2">
            <h4>
              Hey !{" "}
              <span className="text-black font-semibold">
                {" "}
                {CapitalizeFirstLetter(name)}{" "}
              </span>
            </h4>
            <h3 className="text-sm text-gray-500">{email}</h3>
          </div>
        </div>

        {/* Second Div with Buttons */}
        {/* <div className="secondDiv  space-x-5 items-center mx-5 hidden md:flex">
          <button
            className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
            onClick={GenerateRFPForm}
          >
            <PlusIcon color="white" size="14px" /> Generate RFP
          </button>
        </div> */}

        {/* Burger Icon for Small Screens */}
        <button
          onClick={toggleMenu}
          className="flex items-center justify-center p-2 bg-white shadow-md rounded-full sm:block md:hidden"
        >
          <FiMenu className="text-2xl" />
        </button>

        {/* Responsive Menu */}
        {isMenuOpen && (
          <div className="fixed top-16 right-4 bg-white shadow-md rounded-md p-4 flex flex-col space-y-3 items-center space-x-2 z-40 md:hidden">
            <BellAlert className="text-red-500 text-xl" />
            <button
              className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-blue-500"
              onClick={GenerateRFPForm}
            >
              <PlusIcon color="white" size="14px" /> clipPath
            </button>
          </div>
        )}

        {
          <Modal
            open={rfpModalOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="relative"
          >
            <Box className="h-full w-full bg-white">
              <ClientRFPModal
                setRfpModalOpen={GenerateRFPForm}
                rfpModalOpen={rfpModalOpen}
              />
            </Box>
          </Modal>
        }
      </div>
    </div>
  );
};

export default Header;
